import { useState } from "react";
import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Spinner } from "@/components/States";

const ORDER = ["starter", "studio", "pro"];
const fmt = (n) => `$${n.toLocaleString("en-CA")}`;

export function features(p) {
  return [
    p.seats ? `${p.seats} team seats` : "Unlimited team seats",
    p.projects ? `${p.projects} active projects` : "Unlimited projects",
    "Schedule, trade passes, site binder & expenses",
    "Client window, wishlist & design boards",
    "Your name, logo & colours",
    ...(p.white_label ? ["Crew timesheets, daily logs & invoicing from hours", "Your own subdomain"] : []),
  ];
}

export function IntervalToggle({ value, onChange }) {
  return (
    <div className="inline-flex rounded-full border bg-card p-1 text-sm" role="tablist" data-testid="interval-toggle">
      {[["monthly", "Monthly"], ["yearly", "Yearly · 2 months free"]].map(([k, l]) => (
        <button key={k} type="button" role="tab" aria-selected={value === k} onClick={() => onChange(k)} data-testid={`interval-${k}`}
          className={`rounded-full px-4 py-1.5 transition-colors ${value === k ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"}`}>{l}</button>
      ))}
    </div>
  );
}

export default function PlanCards({ plans, interval, current, onChoose, busyKey, cta = "Choose" }) {
  const [hover, setHover] = useState(null);
  return (
    <div className="grid gap-5 lg:grid-cols-3">
      {ORDER.map((k, i) => {
        const p = plans[k];
        const isCurrent = current === k;
        const featured = k === "studio";
        return (
          <div key={k} onMouseEnter={() => setHover(k)} onMouseLeave={() => setHover(null)} data-testid={`plan-card-${k}`}
            className={`rise relative flex flex-col rounded-2xl border p-7 transition-shadow ${featured ? "spruce border-transparent" : "bg-card"} ${hover === k ? "shadow-xl" : ""}`} style={{ animationDelay: `${i * 80}ms` }}>
            {featured && <span className="absolute -top-3 left-7 rounded-full bg-accent px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] text-accent-foreground">Most popular</span>}
            <p className={`eyebrow ${featured ? "!text-white/70" : ""}`}>{p.name}</p>
            <p className="stat mt-4 text-4xl" data-testid={`plan-price-${k}`}>{fmt(interval === "yearly" ? Math.round(p.yearly / 12) : p.monthly)}<span className={`ml-1 text-sm ${featured ? "text-white/60" : "text-muted-foreground"}`}>/mo CAD</span></p>
            <p className={`mt-1 text-xs ${featured ? "text-white/60" : "text-muted-foreground"}`}>{interval === "yearly" ? `${fmt(p.yearly)} billed yearly` : "billed monthly"}</p>
            <p className={`mt-4 text-sm ${featured ? "text-white/80" : "text-muted-foreground"}`}>{p.blurb}</p>
            <ul className="mt-6 flex-1 space-y-2 text-sm">
              {features(p).map((f) => <li key={f} className="flex gap-2"><Check className="mt-0.5 h-4 w-4 shrink-0 text-accent" />{f}</li>)}
            </ul>
            <Button className="mt-8 rounded-full" variant={featured ? "secondary" : "default"} disabled={isCurrent || !!busyKey} onClick={() => onChoose(k)} data-testid={`plan-choose-${k}`}>
              {busyKey === k ? <Spinner /> : isCurrent ? "Current plan" : `${cta} ${p.name}`}
            </Button>
          </div>
        );
      })}
    </div>
  );
}
